module.exports = __webpack_public_path__ + "img/webinars-2.0412fbce.png";